export function sentenceCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Converts camelCase to human-readable words with proper capitalization
 * @param {string} string - The camelCase string to convert
 * @returns {string} - Human-readable string with words separated by spaces and capitalized
 * @example
 * camelCaseToWords('camelCaseString') // Returns 'Camel Case String'
 */
export function camelCaseToWords(string) {
  if (!string) {
    return '';
  }

  // Add a space before capital letters and convert to lowercase
  const withSpaces = string.replace(/([A-Z])/g, ' $1').toLowerCase();

  // Capitalize the first letter of each word
  return withSpaces
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .trim();
}
